import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IContactPreferencesState {
	printToPost: boolean;
}

const INITIAL_STATE: IContactPreferencesState = {
	printToPost: false,
};

export const contactPreferencesSlice = createSlice({
	name: 'contactPreferences',
	initialState: INITIAL_STATE,
	reducers: {
		clearContactPreferences: () => ({
			...INITIAL_STATE,
		}),
		updatePrintToPost: (state, action: PayloadAction<boolean>) => ({
			...state,
			printToPost: action.payload,
		}),
	},
});

export const { updatePrintToPost, clearContactPreferences } = contactPreferencesSlice.actions;
export default contactPreferencesSlice.reducer;
